import { useId, useState } from 'react'

import TextField from 'ageas-react-component-textfield'

import { t } from '../../i18n'

type NIFProps = {
  onClick: () => void
  readOnly?: boolean
  onValueChanged: (value: string) => void
  required?: boolean
  value: string | undefined
  label?: string
  errorMessage: string | null
  optionalLabel?: boolean
}

export const NIF = ({
  onClick,
  readOnly,
  onValueChanged,
  required,
  value,
  errorMessage,
  optionalLabel,
  label = t('pages.step1.vatNumber'),
}: NIFProps) => {
  const [pristineNif, setPristineNif] = useState(false)
  const ID = useId()

  return (
    <>
      <TextField
        maxLength={9}
        mask="#########"
        isSearch
        readOnly={readOnly}
        id={`policyVatNumber-${value}-${ID}`}
        label={label}
        required={required}
        onValueChanged={(id: string, _value: string) => {
          onValueChanged(_value)
          if ((_value || '').length > 0) {
            setPristineNif(true)
          } else {
            setPristineNif(false)
          }
        }}
        colorTheme="blue"
        message={errorMessage}
        messageType={
          (value || '').length === 0 && pristineNif ? 'error' : 'warning'
        }
        version="2"
        optionalLabel={optionalLabel}
        value={value}
        onClick={() => {
          if ((value || '')?.length > 0) {
            onClick()
          }
        }}
      />
    </>
  )
}
